<template>
  <div class="home wh100">

    <transition name="fade">
      <add-user v-if="masa" />
    </transition>

    <audio v-if="isOpen"
           id="audio"
           controls
           autoplay
           src="http://188.213.133.198:8000/home">
      Your browser does not support the
      <code>audio</code> element.
    </audio>

    <figure class="h100 flex-center relative"
            v-html="svg.bar"></figure>

    <section class="fixed wh100 left0 top0 click-disabled">
      <ul class="users absolute"
          v-show="users['Open-Pub-' + place] && users['Open-Pub-' + place].length > 0"
          :id="'users-' + place"
          v-for="(place, index) in places"
          :key="index">
        <li class="capitalize"
            v-for="(item, key) in users['Open-Pub-' + place]"
            :key="key">
          {{ item }}
        </li>
      </ul>
    </section>

  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Home',

  data () {
    return {
      places: ['bar', 'masa-unu', 'masa-doi', 'masa-trei'],
      left: {}
    }
  },

  computed: {
    ...mapState({
      svg: 'svg',
      masa: 'masa',
      meetings: 'meetings',
      users: 'users',
      isOpen: 'isOpen'
    })
  },

  created () {
    // this.setOpeningHours()
    this.$store.dispatch('get_zoom')
    setInterval(() => {
      this.$store.dispatch('get_zoom')
    }, 5000)
    this.$store.dispatch('get_sse_events')
    /* reposition bg img */
    this.$nextTick(() => {
      if (window.innerWidth > 769) {
        const svg = document.querySelectorAll('figure')[0].children[0]
        const landscape = window.innerWidth / window.innerHeight > 1.468
        landscape ? svg.style.width = '100%' : svg.style.width = '100%'
      }
    })
  },

  mounted () {
    document.addEventListener('click', this.click, {passive: true})
    this.places.forEach(place => {
      this.getDotCoordinates(place)
    })
    if (window.innerWidth < 769) {
      document.getElementsByTagName('figure')[0].addEventListener('scroll', this.scrollMobile, { passive: true })
      this.places.forEach(place => {
        const elm = document.getElementById(`users-bar`)
        this.left[place] = {
          elm: document.getElementById(`users-${place}`),
          L: +document.getElementById(`users-${place}`).style.left.replace('px', '')
        }
      })
    }
    this.isOpen && this.setAudioVolume()
  },

  methods: {
    setAudioVolume () {
      const audio = document.getElementById("audio")
      audio.volume = 0.3
    },

    scrollMobile (ev) {
      const left = ev.target.scrollLeft
      for (let key in this.left) {
        this.left[key].elm.style.left = this.left[key].L - left + 'px'
      }
    },

    setOpeningHours () {
      const d = new Date()
      const hours = d.getHours()
      this.$store.commit('SET_KEY_VALUE', {
        key: 'isOpen',
        value: +hours >= 20 || +hours <= 1
      })
    },

    click (ev) {
      let id = ev.target.id
      if (id.indexOf('zoom') > -1) {
        id = id.replace('zoom-', '')
        window.open(this.meetings[id].join_url, '_blank')
      }
    },

    getDotCoordinates (place) {
      const elm = document.getElementById(`users-dot-${place}`)
      const { x, y } = elm.getBoundingClientRect()
      const placeElm = document.getElementById(`users-${place}`)
      placeElm && (placeElm.style.left = `${x + 6}px`)
      placeElm && (placeElm.style.top = `${y + 6}px`)
    }
  },

  destroyed() {
    document.removeEventListener('click', this.click)
  }
}
</script>

<style lang="less">
  .home {

    #audio {
      position: fixed;
      z-index: 99;
      top: 0;
      transform: translateX(calc(-50%));
    }

    figure {
      overflow: scroll;

      svg {
        flex: 1 0 auto;
      }

      @media only screen and (max-width: 769px) {
      	svg {
          height: 100%;
        }
      }
    }

    #zoom-bar,
    #zoom-masa-unu,
    #zoom-masa-doi,
    #zoom-masa-trei {
      cursor: pointer;
      transition: transform .2s ease-in-out;
      &:hover {
        transform: translateY(-10px);
      }
    }

    ul.users {
      left: 0;
      top: 0;
      padding: 8px 16px;
      background-color: #333;
      border-radius: 4px;
      border: 1px solid grey;
      font-size: 1.8rem;
      text-align: left;
      color: white;
    }
  }
</style>
